module.exports = __webpack_public_path__ + "static/media/goodnest_job2_preview.2ead4d6d.jpg";